import { Notice } from "@bokio/designsystem/components/Notice/Notice";
import Markdown from "@bokio/elements/Markdown/Markdown";
import { GeneralLangFactory } from "@bokio/lang";
import { getRoute } from "@bokio/shared/route";
import { formatMessage } from "@bokio/shared/utils/format";

import type { FC } from "react";

import * as styles from "./failedPaymentTopBar.scss";

interface ExpiringCardTopBarProps {
	company: string;
	isExpired: boolean;
}

export const ExpiringCardTopBar: FC<ExpiringCardTopBarProps> = ({ company, isExpired }) => {
	const lang = GeneralLangFactory();
	const billingSettingsRoute = "bokio:" + getRoute("billing", { company }, { tab: "settings" });
	const message = isExpired
		? formatMessage(lang.ExpiringCard_Expired_Bar_Text, billingSettingsRoute)
		: formatMessage(lang.ExpiringCard_ExpiringSoon_Bar_Text, billingSettingsRoute);

	return (
		<Notice
			color={isExpired ? "error" : "warning"}
			margin={[]}
			className={styles.topBarNotice}
			hasIcon={false}
			testId="ExpiringCardTopBar"
		>
			<div className={styles.topBarContent}>
				<span className={styles.topBarSymbol}>!</span>
				<Markdown markdownContent={message} deprecatedOptoutFromTypographicElements />
			</div>
		</Notice>
	);
};
